<template>
  <div v-if="loaded">
    <BarProgressStepper
      v-if="steps"
      class="mx-base mb-twentyFive"
      :total-steps="steps"
      :current-step="step"
      :start-label="$t('bulkSend.start')"
      :end-label="$t('bulkSend.complete')"
    />

    <KeepAlive v-if="isStepsRoute">
      <RouterView />
    </KeepAlive>
    <RouterView v-else />
  </div>
</template>

<script>
// @ts-check
import { defineComponent } from 'vue';
import { mapActions, mapGetters } from 'vuex';

import useBulkSendRoutes from '@/composables/bulkSend/routes';
import { useBulkSendStepsProgress } from '@/composables/bulkSend/steps';

import BarProgressStepper from '@/components/library/progressSteppers/BarProgressStepper/BarProgressStepper.vue';

/**
 * StepsPage shows the current "step" with progress bar
 */
export default defineComponent({
  name: 'StepsPage',
  components: { BarProgressStepper },
  setup() {
    const { isStepsRoute, progressRoute } = useBulkSendRoutes();
    const { steps, step } = useBulkSendStepsProgress();

    return {
      steps,
      step,
      isStepsRoute,
      progressRoute,
    };
  },
  async mounted() {
    try {
      await this.fetchBulkSend(this.$route.params.fingerprint);
    } catch (_) {
      await this.$router.push({ name: 'BulkSends' });
      return;
    }

    if (this.progressRoute.name !== this.$route.name) {
      await this.$router.replace(this.progressRoute);
    }
  },
  beforeRouteUpdate(to, __, next) {
    if (this.isSent && to.name !== this.progressRoute.name) {
      next(this.progressRoute);
    }

    next();
  },
  beforeRouteLeave(to, __, next) {
    if (!/^BulkSends(Step|Edit).*$/.test(to.name)) {
      this.resetBulkSend();
    }

    next();
  },
  methods: {
    ...mapActions({
      resetBulkSend: 'bulkSend/resetBulkSend',
      fetchBulkSend: 'bulkSend/fetchBulkSend',
    }),
  },
  computed: {
    ...mapGetters({
      loaded: 'bulkSend/loaded',
      isSent: 'bulkSend/isSent',
    }),
  },
});
</script>
